import Autocomplete from "@mui/lab/Autocomplete";
import TextField from "@mui/material/TextField/TextField";
import { useMemo } from "react";
import { useSelector } from "react-redux";

interface CityOption {
  label: string;
  id: number;
}

interface Props {
  onSelect?: (cities: CityOption[]) => void;
}

export const NotificationsTargetCity = ({ onSelect }: Props) => {
  const cities = useSelector((s: any) => s.cities?.citiesList);

  const cityOptions: CityOption[] = useMemo(() => {
    return cities
      ? cities.map((c: any) => {
          return {
            label: c.name,
            id: c.id,
          };
        })
      : [];
  }, [cities]);

  return (
    <Autocomplete
      multiple={true}
      options={cityOptions}
      onChange={(_, value) => onSelect?.(value)}
      renderInput={(params) => (
        <TextField {...params} label="City" placeholder="Select Cities" />
      )}
    />
  );
};
